<template>
  <div class="h-screen flex w-full bg-img">
    <div
      class="flex flex-col items-center justify-center sm:w-1/2 md:w-3/5 lg:w-3/4 xl:w-1/2 mx-auto text-center"
    >
      <img
        :src="require('../assets/images/404.png')"
        alt="graphic-404"
        class="mx-auto mb-4 max-w-full"
      >
      <h1 class="sm:mx-0 mx-4 mb-12 text-5xl d-theme-heading-color">
        {{ $t("404_error_text") }}
      </h1>
      <router-link to="/">
        <a-button
          type="primary"
        >
          {{ $t("back_home") }}
        </a-button>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Error',
}
</script>

<style scoped>

</style>
